export class MeshSheetSize
{
    public constructor(public readonly numRows:number,
                       public readonly numCols:number)
    {
    }

    public static singleCell():MeshSheetSize
    {
        return new MeshSheetSize(1, 1);
    }
}
